// extracted by mini-css-extract-plugin
module.exports = {"main":"AboutUs_main__NMne0","diamonds":"AboutUs_diamonds__1sMI3","side":"AboutUs_side__12fds","content":"AboutUs_content__3W5jV","line":"AboutUs_line__3hm8P"};